import React from 'react'
import { Box, Typography } from '@mui/material'
import { getDefaultStringInsteadOfNull } from '@shared/utils/get-default-string-instead-of-null'
import MultilineContainer from '@shared/components/multiline-container'

interface Props {
  content: string | null
}

export const FormSectionContent = ({ content }: Props) => {
  return (
    <Typography variant="body1">
      <Box component="span" paddingTop={0.75} marginTop={0.75}>
        <MultilineContainer>
          {getDefaultStringInsteadOfNull(content)}
        </MultilineContainer>
      </Box>
    </Typography>
  )
}
